import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import './EditPropertyName.scss'

const useStyles = theme => ({
  root: {
    margin: 0,
    padding: '17px 20px',
    '& .MuiDialog-paper': {
      overflowY: 'hidden !important'
    }
  },
  formControlRoot: {
    width: '500px',
    height: '140px',
    marginLeft: '8px'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  muiDialogActions: {
    padding: '0px'
  }
})

export class EditPropertyName extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      propertyName: props.name,
      done: false,
      propNameExists: false
    }
  }

  // componentDidUpdate = prevProps => {
  //   console.log('iiin componentDidUpdate')
  //   if ((prevProps.name !== this.props.name)) {
  //     this.setState({
  //       propertyName: this.props.name
  //     })
  //   }
  // }

  render() {
    const { isDialogOpen, dialogTitle, classes, editPropertyNameDialog, propertyNameList } = this.props
    const { propertyName } = this.state
    const propertyNamemaxLimit = 32

    const editPropertyName = name => {
      if (name.length === 0) {
        this.setState({ propertyName: name, done: false, propNameExists: false })
      } else if (propertyNameList?.includes(name.toUpperCase())) {
        this.setState({ ...this.state, propertyName: name, propNameExists: true, done: false })
      } else {
        this.setState({ ...this.state, propertyName: name, propNameExists: false, done: true })
      }
    }

    const savePropertyName = () => {
      this.props.doneDialog({ pname: this.state.propertyName })
      this.props.closeEditPopup()
    }

    const handleReset = () => {
      this.setState({ propertyName: this.props.name, propNameExists: false, done: false })
    }

    return (
      <div>
        <Dialog
          open={isDialogOpen}
          maxWidth={'sm'}
          className={classes.root}
          data-testid="edit-propertyname-dialog"
        >
          <DialogTitle disableTypography>
            <div className="property-details">
              <div className="title">{dialogTitle}</div>
              <IconButton aria-label="close" onClick={editPropertyNameDialog} data-testid="propertyDetails-comps-dialog-close">
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle >
          <DialogContent>
            <FormControl classes={{ root: classes.formControlRoot }} variant="outlined">
              <TextField
                id="propertyname"
                inputProps={{ 'data-testid': 'input-propertyname-comps', maxLength: propertyNamemaxLimit }}
                label="Property Name"
                value={propertyName}
                variant="outlined"
                onChange={e => editPropertyName(e.target.value)}
              />
            </FormControl>
          </DialogContent>
          <DialogActions className={classes.muiDialogActions}>
            <div className="action-area-propertyName">
              <div className="btn-boxes">
                <div className="error-msg">
                  {this.state.propertyName.length >= propertyNamemaxLimit && (
                    <span data-testid="error-msg-max-limit">Property Name max limit {propertyNamemaxLimit} reached.</span>
                  )}
                  {this.state.propNameExists && (
                    <span data-testid="error-msg-exist-pname">Property Name already exist.</span>
                  )}
                </div>

                <Button className="btn reset" data-testid="edit-propertyname-reset" id="edit-propertyname-reset" color="primary" variant="contained" size="large" onClick={handleReset} >Reset</Button>
                <Button className="btn done" data-testid="edit-propertyname-done" id="edit-propertyname-done" color="primary" variant="contained" size="large" onClick={savePropertyName} disabled={!this.state.done} >
                  <span className="tick"><img src="/images/btn_done.svg" /></span> Done
                </Button>
              </div>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

EditPropertyName.propTypes = {
  isDialogOpen: PropTypes.bool,
  name: PropTypes.string,
  dialogTitle: PropTypes.string,
  editPropertyNameDialog: PropTypes.func,
  closeEditPopup: PropTypes.func,
  classes: PropTypes.object,
  doneDialog: PropTypes.func,
  propertyNameList: PropTypes.array
}

export default withStyles(useStyles)(EditPropertyName)
